import React from 'react';
import MainHeader from "./components/MainHeader"
import './App.css';

function App() {
  return (
    <div className="App colorful">
     <MainHeader />
    </div>
  );
}

export default App;
